var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui warning message"},[_c('i',{staticClass:"close icon"}),_c('div',{staticClass:"header"},[_vm._v(" Keine "+_vm._s(_vm.name)+" gefunden. ")]),_vm._v(" Bitte einen Eintrag anlegen. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }